<template>
  <ChapterBlockTemplateLinkItems v-if="posts.length">
    <ChapterBlockPostItem
      v-for="post in posts"
      :id="post.id"
      :key="post.id"
      :content-type="post.contentType"
      :library-book-id="libraryBookId"
      :locked-content="post.lockedContent ?? ''"
      :icon="post.icon"
      :path="post.path"
      :text="post.title"
      :selectable="false"
      :locked="isTypePostLocked"
    />
  </ChapterBlockTemplateLinkItems>
</template>
<script lang="ts" setup>
interface ViewProps {
  category: CategorySchema;
}
const props = defineProps({
  category: null
});

const { currentContent } = inject(INJECT_CATEGORY_PAGE);

const libraryBookId = computed(() => currentContent.value.id);

const { isTypePostLocked, posts } = useCategoryBlockPosts(props.category);
</script>
<style lang="scss" scoped></style>
